
import { Component, Vue } from "vue-property-decorator";
import { MetaInfo } from "vue-meta";
// import Navbar from "@/components/Utility/Navbar.vue";
// import Footer from "@/components/Utility/Footer.vue";
@Component({
  components: {
    // Navbar,
    // Footer,
  },
})
export default class Law extends Vue {
  metaInfo(): MetaInfo {
    return {
      title: "法律條款｜師虎來了平台使用協議",
      meta: [
        {
          vmid: "description",
          name: "description",
          content:
            "師虎來了平台使用協議及 Pro 會員服務條款，說明帳號使用規範、付款、保固責任及爭議處理方式等權利義務，使用本服務前請詳細閱讀。",
        },
        {
          vmid: "og:title",
          property: "og:title",
          content: "法律條款｜師虎來了平台使用協議",
        },
        {
          vmid: "og:description",
          property: "og:description",
          content:
            "師虎來了平台使用協議及 Pro 會員服務條款，說明帳號使用規範、付款、保固責任及爭議處理方式等權利義務，使用本服務前請詳細閱讀。",
        },
      ],
      link: [
        {
          vmid: "canonical",
          rel: "canonical",
          href: "https://www.fdtigermaster.com/Law",
        },
      ],
    };
  }
}
